/* src/app/forms/produtos/shopee/shopee-var-new/shopee-var-new.component.scss */
:host {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=shopee-var-new.component.css.map */
